import { firebase } from '../config/configureFirebase';
import store from '../store/store';

export const RequestPushMsg = (token, data) => {
    if (!token || token.trim() === '') {
        console.warn("[Client RequestPushMsg] Discarding invalid push token:", token);
        return;
    }
    console.log(`[Client RequestPushMsg] Token: ${token}, Payload:`, data);
    const {
        config
    } = firebase;
    
    const settings = store.getState().settingsdata.settings;
    let host = window && window.location && settings.CompanyWebsite === window.location.origin? window.location.origin : `https://${config.projectId}.web.app`
    let url = `${host}/send_notification`;

    console.log(`[Client RequestPushMsg] Requesting URL: ${url}`);
    fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            "token": token,
            ...data
        })
    })
    .then(async (response) => {
        const text = await response.text();
        console.log(`[Client RequestPushMsg] Response (Status: ${response.status}):`, text);
    })
    .catch((error) => {
        console.error(`[Client RequestPushMsg] Fetch Error:`, error);
    });
}